export const getStatusBadgeColor = (status: string) => {
  switch (status.toLowerCase()) {
    case "scheduled":
      return "bg-gray-100 text-gray-800 border-gray-200 dark:bg-slate-700 dark:text-slate-200 dark:border-slate-600";
    case "confirmed":
      return "bg-gray-100 text-gray-800 border-gray-200 dark:bg-slate-700 dark:text-slate-200 dark:border-slate-600";
    case "in_progress":
      return "bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-950 dark:text-blue-200 dark:border-blue-800";
    case "completed":
      return "bg-green-100 text-green-800 border-green-200 dark:bg-green-950 dark:text-green-200 dark:border-green-800";
    case "cancelled":
      return "bg-red-100 text-red-800 border-red-200 dark:bg-red-950 dark:text-red-200 dark:border-red-800";
    default:
      return "bg-gray-100 text-gray-800 border-gray-200 dark:bg-slate-700 dark:text-slate-200 dark:border-slate-600";
  }
};

export const translateStatus = (status: string) => {
  switch (status.toLowerCase()) {
    case "scheduled":
      return "Agendado";
    case "confirmed":
      return "Confirmado";
    case "in_progress":
    case "inprogress":
      return "Em Andamento";
    case "completed":
      return "Concluído";
    case "cancelled":
      return "Cancelado";
    default:
      return status;
  }
};

/** Tailwind classes for car text/background by effort (Leve = green, Médio = yellow, Pesado = red). */
export const getCarEffortColor = (effort: string | null | undefined) => {
  switch (effort) {
    case "Leve":
      return "text-green-700 bg-green-50 border-green-200 dark:text-emerald-300 dark:bg-emerald-950 dark:border-emerald-700";
    case "Médio":
      return "text-amber-700 bg-amber-50 border-amber-200 dark:text-amber-300 dark:bg-amber-950 dark:border-amber-700";
    case "Pesado":
      return "text-red-700 bg-red-50 border-red-200 dark:text-rose-300 dark:bg-rose-950 dark:border-rose-700";
    default:
      return "text-gray-700 bg-gray-50 border-gray-200 dark:text-slate-200 dark:bg-slate-900 dark:border-slate-600";
  }
};

/** Text color only for car by effort (for inline text). */
export const getCarEffortTextColor = (effort: string | null | undefined) => {
  switch (effort) {
    case "Leve":
      return "text-green-600 dark:text-green-400";
    case "Médio":
      return "text-amber-600 dark:text-amber-400";
    case "Pesado":
      return "text-red-600 dark:text-red-400";
    default:
      return "text-gray-700 dark:text-slate-200";
  }
};

export const getPaymentMethodColor = (method: string | null | undefined) => {
  switch (method) {
    case "PIX":
      return "bg-blue-200 text-blue-900 border-blue-300 font-semibold dark:bg-blue-950 dark:text-blue-200 dark:border-blue-700";
    case "Débito":
      return "bg-emerald-200 text-emerald-900 border-emerald-300 font-semibold dark:bg-emerald-950 dark:text-emerald-200 dark:border-emerald-700";
    case "Crédito":
      return "bg-violet-200 text-violet-900 border-violet-300 font-semibold dark:bg-violet-950 dark:text-violet-200 dark:border-violet-700";
    case "Dinheiro":
      return "bg-amber-200 text-amber-900 border-amber-300 font-semibold dark:bg-amber-950 dark:text-amber-200 dark:border-amber-700";
    default:
      return "bg-slate-200 text-slate-800 border-slate-300 font-semibold dark:bg-slate-700 dark:text-slate-100 dark:border-slate-500";
  }
};

function normalizeTimeForSort(value?: string | null): string {
  if (!value) return "";
  const match = value.match(/^(\d{1,2}):(\d{2})/);
  if (!match) return "";
  return `${match[1].padStart(2, "0")}:${match[2]}`;
}

/** Car appointments: earliest delivery end first; without delivery time goes last. */
export function sortAppointmentsByDeliveryEndTime<
  T extends { deliveryEndTime?: string | null; startTime?: string | null }
>(appointments: T[]): T[] {
  return [...appointments].sort((a, b) => {
    const aEnd = normalizeTimeForSort(a.deliveryEndTime);
    const bEnd = normalizeTimeForSort(b.deliveryEndTime);

    if (!aEnd && !bEnd) {
      return normalizeTimeForSort(a.startTime).localeCompare(
        normalizeTimeForSort(b.startTime)
      );
    }
    if (!aEnd) return 1;
    if (!bEnd) return -1;
    return aEnd.localeCompare(bEnd);
  });
}

export const toAppointmentDateOnly = (value?: string | null): string => {
  if (!value) return "";
  return value.split("T")[0];
};

export const appointmentSpansMultipleDays = (appointment: {
  appointmentDate: string;
  appointmentEnd?: string | null;
}): boolean => {
  const start = toAppointmentDateOnly(appointment.appointmentDate);
  const end = toAppointmentDateOnly(appointment.appointmentEnd);
  return Boolean(start && end && end > start);
};

